{
  "version": 1,
  "name": "Late Braker",
  "basedOn": "medium",
  "knobs": {
    "depth": 6,
    "courseSense": "time",
    "temperature": 0.144,
    "aimErrorM": 1.86,
    "brakeConfidence": 1.6,
    "nudges": true,
    "contactRoots": 8,
    "forecastHulls": false,
    "followDistance": false,
    "aggression": 0,
    "blockMaxCostTurns": 1,
    "blockMinGainTurns": 0.5,
    "width": 48,
    "density": 40,
    "rootDensity": 96,
    "verify": 12
  }
}
